// Single responsibility: provide shared dashboard search configuration constants.
export const SEARCH_SCORE_THRESHOLD = 10;
export const SEARCH_ACTION_SCORE_THRESHOLD = 8;
export const SEARCH_MAX_RESULTS = 10;
export const SEARCH_MAX_INVENTORY_RESULTS = 12;
export const SEARCH_MAX_ACTION_RESULTS = 8;
export const SEARCH_DEFAULT_ACTION_SCORE = 45;
export const SEARCH_DEBOUNCE_MS = 300;
export const SEARCH_MIN_QUERY_LENGTH = 2;
export const SEARCH_PLACEHOLDER = "Search Dashboard";
export const SEARCH_SELECTION_GUARD_MS = 300;

export const SCORE_WEIGHTS = {
  exactMatch: 180,
  prefixMatch: 135,
  fuzzyMatch: 100,
  nameField: 1.1,
  batchField: 0.85,
};

export const RESULT_TYPES = {
  INVENTORY: "inventory",
  ACTION: "action",
  NAVIGATION: "navigation",
};
